import React from 'react';
import {
  Button,
  Modal,
  ModalProps,
  Radio,
  Row,
  Space,
} from 'antd';

export enum DownloadFileType {
  Merge = 1,
  Independ = 2,
};

type Props = ModalProps & {
  doDownloadAction: Function;
};

const DownloadFileOptionsDialog = (props: Props) => {
  const { useState } = React;
  const [attrs, setAttrs] = useState<StringKAnyVPair>({});
  const [downloadType, setDownloadType] = useState(false);
  const [inited, setInited] = useState(false);

  const dialogFooter = () => {
    return (
      <Row justify="end">
        <Space>
          <Button onClick={onCancel}>
            Cancel
          </Button>
          <Button
            disabled={!isDownloadTypeSelected()}
            onClick={onOk}
            type="primary"
          >
            OK
          </Button>
        </Space>
      </Row>
    );
  };

  const isDownloadTypeSelected = () => {
    return typeof downloadType === 'number';
  };

  const onCancel = (evt: any) => {
    if (props.onCancel) props.onCancel(evt);
  };

  const onDownloadTypeChange = (evt: any) => {
    setDownloadType(evt.target.value);
  };

  const onOk = (evt: any) => {
    props.doDownloadAction(downloadType);
    onCancel(evt);
  };

  React.useEffect(() => {
    if (!inited) {
      const ps = { ...props };

      setAttrs(ps);
      setInited(true);
    }
  }, [inited, props]);

  return (<>
    <Modal
      { ...attrs }
      footer={dialogFooter()}
    >
      <Radio.Group onChange={onDownloadTypeChange} value={downloadType}>
        <Space direction="vertical">
          <Radio value={DownloadFileType.Merge}>Download merged file</Radio>
          <Radio value={DownloadFileType.Independ}>Download individual files</Radio>
        </Space>
      </Radio.Group>
    </Modal>
  </>);
};

export default DownloadFileOptionsDialog;
